export default "__VITE_ASSET__CPhbbnXx__"